(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hw-featured-products"] && !Shopify.designMode) return;
  try {
    
  function initHwFeaturedRotator(grid) {
    if (grid.getAttribute('data-hw-rotator-ready') === 'true') return;
    grid.setAttribute('data-hw-rotator-ready', 'true');
    const cards = Array.from(grid.children).filter(function (el) {
      return el.classList && el.classList.contains('hw-product-card-wrapper');
    });
    const visible = Math.min(parseInt(grid.getAttribute('data-visible'), 10) || 16, cards.length);
    if (cards.length === 0) return;

    cards.forEach(function (card) {
      card.hidden = false;
    });

    if (cards.length <= visible) return;

    const intervalMs = Math.max(4000, parseInt(grid.getAttribute('data-interval'), 10) || 10000);
    const step = 4;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let offset = Math.floor(Date.now() / intervalMs) % cards.length;
    let timer = null;

    function paint() {
      cards.forEach(function (card, i) {
        const pos = (i - offset + cards.length) % cards.length;
        const show = pos < visible;
        card.hidden = !show;
        card.style.order = String(pos);
      });
    }

    function apply(animate) {
      if (animate && !reduceMotion) {
        grid.classList.add('is-swapping');
        window.setTimeout(function () {
          paint();
          grid.classList.remove('is-swapping');
        }, 180);
      } else {
        paint();
      }
    }

    function tick() {
      if (document.hidden) return;
      offset = (offset + step) % cards.length;
      apply(true);
    }

    function start() {
      if (timer || reduceMotion) return;
      timer = window.setInterval(tick, intervalMs);
    }

    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    paint();
    if (reduceMotion) return;

    grid.addEventListener('mouseenter', stop);
    grid.addEventListener('mouseleave', start);
    grid.addEventListener('focusin', stop);
    grid.addEventListener('focusout', function (event) {
      if (!grid.contains(event.relatedTarget)) start();
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });
    start();
  }

  function bootHwFeaturedRotators() {
    document.querySelectorAll('[data-hw-featured-rotator]').forEach(initHwFeaturedRotator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootHwFeaturedRotators);
  } else {
    bootHwFeaturedRotators();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
